module.exports = __webpack_public_path__ + "static/media/kkLogo.b0fa5b59.png";